module.exports = __webpack_public_path__ + "static/img/erweima2.b5ef02f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/erweima2.jpg
// module id = Da5g
// module chunks = 41